import { useEffect, useState } from 'react';
import Cards from './cards';
import { motion } from 'framer-motion';
import './Home.css';
import SubscribeButton from './subscribebutton';
import backgroundImage from '../images/mianra.jpg';
import { Footer } from "./footer";
import SuccessfulListening from './middlenote';
import { message } from 'antd';
import axios from 'axios';
import { API_ENDPOINTS,formatBlogContent } from './config';
import { useNavigate } from 'react-router-dom';

const Home = ({ cardData }) => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
 const navigate = useNavigate(); 

   const handleClick = (postId) => {
    navigate(`/blog/${postId}`);
  };
  const scrollVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        type: "spring",
        stiffness: 50
      }
    }
  };

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get(API_ENDPOINTS.LIST_BLOGS_WITH_LIMIT);
        if (Array.isArray(response.data)) {
          setBlogs(response.data);
        }
      } catch (error) {
        console.error("Error fetching blogs:", error);
        message.error("Failed to load blogs");
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  return (
    <div>
      <motion.div
        className="home-container"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        {/* Header section */}
        <div className="home-header">
          <div
            className="background-image"
            style={{ backgroundImage: `url(${backgroundImage})` }}
          ></div>

          <motion.div
            className="hero-section"
            variants={scrollVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            style={{ padding: '1rem' }}
          >
            <p className="title">Her Cup Overflows</p>
            <p className="caption">
              So much to share...<br />
              So much to care...<br />
              In this warfare...!<br />
            </p>
          </motion.div>
        </div>
        <motion.div
          className="note-section"
          variants={scrollVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <div style={{ width: '100%', padding: '0px' }}>
            <p className="subheadinghome" style={{ marginTop: 10 }}> Welcome to hercupoverflows.in</p>
            <p className="subheadinghome"> Adding traces to your spiritual treasure</p>
          </div>
        </motion.div>

        {/* Listening section */}
        <motion.div
          className="hero-section"
          variants={scrollVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <SuccessfulListening />
        </motion.div>

        {/* Mission text + Blogs side by side */}
        <div className="content-wrapper">
          <motion.div
            className="mission-blog-container"
            variants={scrollVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
          >
            {/* Left column */}
            <div className="mission-text">
              <div className="mission-text-content">
                <p>When Boredom invaded and</p>
                <p>Helplessness overpowered</p>
                <p>When passion faded and</p>
                <p>So exhausted</p>
                <p>A hamster wheel or a rat race is all I could comprehend</p>
                <p>2 tim 1:7 was a Jerk to my Loin</p>
                <p>This made me sit right</p>
                <p>Clear my sight</p>
                <p>Take a few sheets in white</p>
                <p>And pen every word so tight</p>
                <p>Hurray..!!this is an Elite</p>
                <p>Reviving streams of Joy</p>
                <p>Yes my friend,
                  <br />God's word revives</p>
                <p>So I set my sight on the
                  <br /> Real Joy giver, </p>
                <p>Lord Jesus Christ,</p>
                <p>the Author and the Accompliser  </p>
                <p>of every good thing and</p>
                <p>commit myself to writing,</p>
                <p>encouraging women with the Holy Scriptures.</p>
                <p>I would love to share testimonials</p>
                <p>and a few side hustle for women and many more....</p>
              </div>
            </div>
            <div className="blog-list">
              {loading ? (
                <p>Loading blogs...</p>
              ) : blogs.length > 0 ? (
                blogs.map(blog => (
                  <div key={blog.id} className="blog-card2"
                   onClick={() => handleClick(blog.id)}>
                    <img src={blog.blog_image} alt={blog.blog_name} className="blog-image" />
                    <h4>{formatBlogContent(blog.blog_name)}</h4>
                    <div
                      className="blog-content"
                      dangerouslySetInnerHTML={{
                        __html: formatBlogContent(blog.blog_content_english, 30)
                      }}
                    ></div>
                  </div>
                ))
              ) : (
                <p>No blogs available.</p>
              )}
            </div>

          </motion.div>
        </div>

        {/* Cards section */}
        <Cards cardData={cardData} />

        {/* Subscribe */}
        <motion.div
          className="subscribe-container"
          variants={scrollVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <SubscribeButton />
        </motion.div>
      </motion.div>
      <Footer />
    </div>
  );
};

export default Home;
